/* Copyright (c) Trimble Inc. All rights reserved. */
import {Box, Button, CircularProgress, createStyles, DialogProps, makeStyles} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import {Dialog, DialogActions, DialogContent, DialogTitle, IconButton} from "@material-ui/core";

import CloseIcon from "@material-ui/icons/Close";
import NotificationActionsDialogComponents from "./NotificationActionsDialogComponents";
import { DropDownContainer } from "modus/components/form/dropdown-container/DropDownContainer";
import { IDropDownOption } from "modus/components/form/dropdown/Dropdown";
import { NotificationActionsProps } from "./TeamNotificationActions";
import { useAsyncAction } from "modus/components/form/async-actions/AsyncAction";
import TeamApprovalServices from "../../services/TeamApprovalService";
import { Alert } from "@material-ui/lab";
import { resolveAPIErrorMessage } from "modus/components/error-message/ErrorMessage";
import { useSelector } from "react-redux";
import { useCurrentTeam } from "libs/security/authorization/Permission";

export const ApproveTeam: React.FC<NotificationActionsProps> = ({
  notification,
  refreshApprovals
}) => {
  const [open, setOpen] = React.useState(false);

  const useStyles = makeStyles(() => {
    return createStyles({
      header: {
        position: "relative",
      },
      dialog: {
        overflowX: "hidden",
      },
    });
  });

  const handleClickOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setOpen(true);
  };

  const handleClose = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setOpen(false);
  };
  const { teamId: storedTeamId } = useCurrentTeam();
  const teamId = useSelector((state: any) =>notification?.resource?.id ?? state?.teamManager?.teams?.currentTeam?.id ?? storedTeamId);
  
  const { state, subscribe } = useAsyncAction(() =>
    TeamApprovalServices.approveTeamRequest(teamId, selectedValue.value, notification.requestedBy?.emailAddress ?? "")
  );

  const handleSubmit = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (state?.status !== "LOADING" && state?.status !== "LOADED") {
      subscribe();
    }
    setTimeout(() => {
      handleClose(event);
      refreshApprovals();
    }, 3000);
  };


  const [maxWidth] = useState<DialogProps["maxWidth"]>("sm");
  const style = useStyles();

  const defaultSelectorValue: IDropDownOption = {
    value: "user",
    title: "User",
  };
  const options: IDropDownOption[] = [
    { value: "user", title: "User", optType: "itemBody" },
    { value: "admin", title: "Admin", optType: "itemBody" },
  ];

  const [selectedValue, setSelectedValue] =
    useState<IDropDownOption>(defaultSelectorValue);
  const handleOnSelect = (value: string) => {
    setSelectedValue(
      options.find((option) => option.value === value) || defaultSelectorValue
    );
  };

  return (
    <>
      <Button color="primary" variant="outlined" onClick={handleClickOpen}>
        Approve
      </Button>
      <Dialog
        fullWidth={true}
        maxWidth={maxWidth}
        open={open}
        onClose={handleClose}
        onClick={(event: React.MouseEvent<HTMLDivElement>) => event.stopPropagation()}
        classes={{
          paper: style.dialog,
        }}
      >
        <DialogTitle>
          New Member Request Review
          <IconButton
            aria-label="close"
            onClick={handleClose}
            style={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {state?.error && state?.status === "LOADED" && (
            <Alert severity="error">
              {resolveAPIErrorMessage(state?.error)}
            </Alert>
          )}
          {!state?.error && state?.status === "LOADED" && (
            <Alert severity="success">{`${notification?.requestedBy?.name} is now the member of ${notification?.requestedBy?.team} team.`}</Alert>
          )}
          <NotificationActionsDialogComponents notification={notification} refreshApprovals={refreshApprovals}/>
          <DropDownContainer
            label={"Role"}
            placeholder={"Select Role"}
            defaultSelectorValue={selectedValue}
            required={true}
            disabled={false}
            options={options}
            handleOnSelect={handleOnSelect}
          />
         
        </DialogContent>
        <DialogActions>
          <Box p={2}>
            <Button 
              disabled={state?.loading}
              onClick={handleSubmit} color="primary" variant="contained">
                {state?.loading && <CircularProgress className="action-loader" />}
              Approve
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ApproveTeam;
